<template>
    <div class="i-markdown-editor">
        <btn l='Редактировать' i='pencil' s='m' @press="edit" />
    </div>
</template>
<script>
import Stackedit from 'stackedit-js';
export default {
    props: ["value"],
    name: 'i-markdown-editor',
    mounted() {},
    methods: {
        edit() {

            const stackedit = new Stackedit();

            // Open the iframe
            stackedit.openFile({
                name: 'Filename', // with a filename
                content: {
                    text: `# lcome to Sberbank DEMO API

### Works with NodeJS+Express+MongoDB

### FrontEnd based on VueJS

 - Все запросы отправляются на ендпоинты
 - asdasdsadsa
 - dsadsadsad
 - sadsadasdasdsa
 - dasasasdasadda


| qwe |  eqwe| asdads |
|--|--|--|
| qwee | eqwqe |


Ендпоинты разделены по папкам в src/endpoints
СМС модуль в папке src/modules/sms.js
Рабочий сервер http://sberbank.sergazin.kz:8080/
API менеджер Псотман - http://sberbank.sergazin.kz:8080/api/postman/

Автор: Сергазин Арман
Все вопросы arman@sergazin.kz` // and the Markdown content.
                }
            });
            let self = this;
            // Listen to StackEdit events and apply the changes to the textarea.
            stackedit.on('fileChange', (file) => {
                console.log('GGG!!', file.content.text)
                self.$emit('input',file.content.text);
            });
        }
    },
    data() {
        return {

        }
    }
}
</script>
<style lang="css" scoped>
</style>